export enum LaunchDarklyFeatureKey {
    GiftCardBalance = 'online-store-check-gift-card-balance',
    LoginOnCheckout = 'online-store-login-on-checkout',
}
